const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const URL_RE = /^https?:\/\/\S+\.\S+/i;

export const SKILLS = ["Talking Head", "Podcast Clips", "Fashion & Editorial", "Brand & Promotional", "Founder Content", "Motion Graphics", "Colour Grading", "Sound Design", "Captions & Subtitles", "Storytelling / Long-form"];
export const SOFTWARE = ["Premiere Pro", "After Effects", "DaVinci Resolve", "Final Cut Pro", "CapCut", "Photoshop", "Blender", "Other"];
export const AVAILABILITY = ["Full-time", "Part-time", "Project-based"];
export const PARTNER_TYPES = ["Agency white-label partnership", "Monthly retainer", "Creator programme", "Other"];
export const VOLUMES = ["1–5 videos / month", "6–15 videos / month", "16–40 videos / month", "40+ videos / month", "Not sure yet"];
export const PLATFORMS = ["Instagram", "YouTube", "LinkedIn", "Facebook", "Website / Ads"];

const base = { name: "", email: "", phone: "", location: "", consent: false, website_hp: "" };
export const EDITOR_EMPTY = { ...base, showreel_url: "", portfolio_links: "", experience_years: "", skills: [], software: [], rate_per_reel_inr: "", rate_notes: "", availability: "", hours_per_week: "", start_date: "", about: "" };
export const PARTNER_EMPTY = { ...base, company: "", company_website: "", application_type: "", monthly_volume: "", platforms: [], sample_links: "", details: "", budget_range: "" };

function common(f, e) {
  if (f.name.trim().length < 2) e.name = "Please enter your name.";
  if (!EMAIL_RE.test(f.email.trim())) e.email = "Enter a valid email.";
  if (!f.consent) e.consent = "Please agree so we can process your application.";
}

export function validateEditor(f) {
  const e = {};
  common(f, e);
  if (!URL_RE.test(f.showreel_url.trim())) e.showreel_url = "Add a showreel or sample link starting with https://";
  const bad = f.portfolio_links.split("\n").map((x) => x.trim()).filter(Boolean).find((x) => !URL_RE.test(x));
  if (bad) e.portfolio_links = "Each link must start with https://";
  const y = Number(f.experience_years);
  if (f.experience_years === "" || !Number.isInteger(y) || y < 0 || y > 50) e.experience_years = "Enter years of experience (0–50).";
  if (!f.skills.length) e.skills = "Pick at least one skill.";
  if (!f.software.length) e.software = "Pick at least one tool.";
  if (f.rate_per_reel_inr !== "" && Number(f.rate_per_reel_inr) < 0) e.rate_per_reel_inr = "Rate can't be negative.";
  if (!f.availability) e.availability = "Choose your availability.";
  if (f.hours_per_week !== "" && (Number(f.hours_per_week) < 1 || Number(f.hours_per_week) > 80)) e.hours_per_week = "Enter 1–80 hours.";
  return e;
}

export function validatePartner(f) {
  const e = {};
  common(f, e);
  if (f.company.trim().length < 2) e.company = "Enter your company or brand.";
  if (f.company_website && !URL_RE.test(f.company_website.trim())) e.company_website = "Use a full link starting with https://";
  if (f.sample_links && !URL_RE.test(f.sample_links.trim())) e.sample_links = "Use a full link starting with https://";
  if (!f.application_type) e.application_type = "Choose what you're applying for.";
  if (f.details.trim().length < 20) e.details = "Tell us a little more (at least 20 characters).";
  return e;
}

const num = (v) => (v === "" || v == null ? null : Number(v));

export const editorPayload = (f) => ({
  ...f, experience_years: Number(f.experience_years), rate_per_reel_inr: num(f.rate_per_reel_inr), hours_per_week: num(f.hours_per_week),
  start_date: f.start_date || null, portfolio_links: f.portfolio_links.split("\n").map((x) => x.trim()).filter(Boolean),
});
